var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLetterA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_38028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1238 48.2447C18.7253 50.0094 20.0917 51.4958 21.98 52.1831L41.5823 59.3178C44.8917 60.5223 48.5509 58.816 49.7554 55.5066L59.6273 28.3837C60.8318 25.0743 59.1255 21.4151 55.8162 20.2106L40.992 14.8151V37.6929C40.992 43.5205 36.2678 48.2447 30.4401 48.2447H18.1238Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.92324C3.75 6.09964 6.84964 3 10.6732 3H30.4405C34.2641 3 37.3637 6.09964 37.3637 9.92324V37.6938C37.3637 41.5174 34.2641 44.617 30.4405 44.617H10.6732C6.84965 44.617 3.75 41.5174 3.75 37.6938V9.92324Z",
    fill: "#FFB2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7613 30.0857C12.7613 31.2087 13.6704 31.9306 14.6597 31.9306C15.5153 31.9306 16.2104 31.4226 16.5045 30.5402L17.2264 28.321H23.7236L24.4722 30.5402C24.7664 31.4226 25.4615 31.9306 26.3171 31.9306C27.3064 31.9306 28.2155 31.2087 28.2155 30.0857C28.2155 29.8183 28.162 29.5509 28.0818 29.337L23.2423 15.7278C22.7343 14.2839 21.9055 13.4284 20.5151 13.4284C19.1248 13.4284 18.3227 14.2839 17.8147 15.7278L12.895 29.337C12.8148 29.5509 12.7613 29.8183 12.7613 30.0857ZM18.3494 24.9789L20.4617 18.6154H20.5419L22.6274 24.9789H18.3494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_38028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLetterA);
export default __webpack_public_path__ + "static/media/icon-letter-a.4c0756ede918006b1937e91e191697bd.svg";
export { ForwardRef as ReactComponent };